///
/// EarthBrowser
///
/// Weather Alert Browser Feature
///
/// Manages alert browser window lifecycle and command palette registration
///
/// Created by Matt Giger on 9/15/2026
/// Copyright (c) 2026 Geodata Labs
///

import { useEffect } from 'react'
import { TriangleAlert } from 'lucide-react'
import { AlertBrowserRenderer } from '@/components/features/alert-browser/AlertBrowser'
import { CommandRegistry } from '@/components/features/CommandRegistry'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { openOrRestoreWindow } from '@/utils/windowUtils'

const ALERT_WINDOW_ID = 'alert-browser'
const ALERT_WINDOW_WIDTH = 780
const ALERT_WINDOW_HEIGHT = 500

export function AlertBrowserFeature() {
	const dispatch = useAppDispatch()
	const datasetWindows = useAppSelector(state => state.dialog.datasetWindows)
	const alertWindow = datasetWindows[ALERT_WINDOW_ID]

	// Register with command palette
	useEffect(() => {
		const unregister = CommandRegistry.registerFeature({
			id: 'alert-browser',
			command: {
				id: 'alerts',
				title: 'Weather Alerts',
				icon: <TriangleAlert className="w-4 h-4 text-amber-400" />,
				category: 'Datasets',
				enabled: true,
				onSelect: () => {
					openOrRestoreWindow(
						dispatch,
						datasetWindows,
						ALERT_WINDOW_ID,
						{
							id: ALERT_WINDOW_ID,
							title: 'Weather Alerts',
							windowType: 'alert',
							x: 100,
							y: 100,
							width: ALERT_WINDOW_WIDTH,
							height: ALERT_WINDOW_HEIGHT,
							isMaximized: false,
							isVisible: true,
						}
					)
				}
			},
			renderBrowser: () => null // Not needed for window-based browser
		})

		return unregister
	}, [dispatch, datasetWindows])

	// Render the window if it's open
	if (!alertWindow) {
		return null
	}

	return (
		<AlertBrowserRenderer
			windowId={ALERT_WINDOW_ID}
			windowState={alertWindow}
		/>
	)
}
